class RoutingRuleset {
  constructor(
    private authenticationConfiguration: any,
    private ngAuthenticationQueryModel: any,
    private ngMemberConfigurationDatastore: any,
    private accountModel: any,
    private $injector: any,
    private $state: ng.ui.IStateService
  ) {}
  transitionWhenLoggedOut() {
    const notInAFailedLoginState = !this.$state.is('authentication.remote.failure');

    if (notInAFailedLoginState && this.ngAuthenticationQueryModel.isAccountLoggedOut()) {
      const loginConfig = this.ngMemberConfigurationDatastore.read((store: any) => store);
      this.$state.go(loginConfig.auth_type.loginInterface, {}, { location: 'replace' });
    }
  }

  transitionWhenLoggedIn() {
    const alreadyLoggedInCommand = this.authenticationConfiguration.read().onLoggedInConfirmation;
    if (this.ngAuthenticationQueryModel.isAccountLoggedIn()) {
      this.$injector.get(alreadyLoggedInCommand)(this.$state, this.accountModel);
    }
  }
}
angular
  .module('capability-ng-authentication')
  .factory(
    'ngRoutingRuleset',
    (
      authenticationConfiguration: any,
      ngAuthenticationQueryModel: any,
      ngMemberConfigurationDatastore: any,
      accountModel: any,
      $injector: any,
      $state: ng.ui.IStateService
    ) =>
      new RoutingRuleset(
        authenticationConfiguration,
        ngAuthenticationQueryModel,
        ngMemberConfigurationDatastore,
        accountModel,
        $injector,
        $state
      )
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-authentication/src/rulesets/transition_ruleset.ts